import React, { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import AdminItemListView from './Switch/AdminItemListView';
import UserItemListView from './Switch/UserItemListView';

export default function ElementContainer({ view, elementID }) {
  const { moduleBridgeHex } = useParams();
  const permissionsLevel = useSelector(
    (s) => s.module[moduleBridgeHex]?.userBridge?.permissions?.level
  );

  const Switch = useCallback(() => {
    switch (view) {
      default:
      case 'list':
        return permissionsLevel === 0 ? (
          <AdminItemListView elementID={elementID} />
        ) : (
          <UserItemListView elementID={elementID} />
        );
      case 'icon':
        return <></>;
    }
  }, [elementID, view, permissionsLevel]);

  return (
    <div className="pt-2">
      <Switch />
    </div>
  );
}
